import React from "react";
import { Answers } from "../types/quiz";
import { quizSteps } from "../data/quizSteps";
import { recapItems } from "../data/recap";
export function AnswersRecap({
  answers,
  name
}: {
  answers: Answers;
  name: string;
}) {
  const rows = recapItems.map(item => {
    const step = quizSteps.find(s => s.id === item.questionId);
    if (!step || step.kind !== "question") return null;
    if (step.input === "age") {
      return answers[item.questionId] ? {
        label: item.label,
        value: `${answers[item.questionId]} años`
      } : null;
    }
    const option = step.options.find(o => o.id === answers[item.questionId]);
    return option ? {
      label: item.label,
      value: option.label
    } : null;
  }).filter((r): r is {
    label: string;
    value: string;
  } => r !== null);
  if (rows.length === 0) return null;
  return <section aria-labelledby="recap-title" className="mt-10" data-id="element-8" data-mp="2ojz2x7f0vhex">
      <h2 id="recap-title" className="font-serif text-xl font-semibold text-cocoa" data-id="element-9" data-mp="2jkutcfo6rho2">
        Lo que nos contaste{name ? `, ${name}` : ""}
      </h2>
      <dl className="mt-4 grid gap-x-8 sm:grid-cols-2" data-id="element-10" data-mp="2gmizfw3u1ymu">
        {rows.map(r => <div key={r.label} className="flex items-baseline justify-between gap-4 border-b border-blush-100 py-3" data-id="element-11" data-mp="2lkb29l60n55t">
            <dt className="text-sm text-cocoa-soft" data-id="element-12" data-mp="2qkyta6u8vm01">{r.label}</dt>
            <dd className="text-right text-sm font-semibold text-cocoa" data-id="element-13" data-mp="2vj0eaxb8dve5">{r.value}</dd>
          </div>)}
      </dl>
    </section>;
}